export const isEmpty = (obj) => {
  if (obj === undefined || obj === null || Object.keys(obj).length === 0) {
    return true;
  } else {
    return false;
  }
};
